<template>
  <div id="app">
    <keep-alive>
      <router-view v-wechat-title="$route.meta.title" v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-wechat-title="$route.meta.title" v-if="!$route.meta.keepAlive"></router-view>
    <transition name="demo">
      <Loading v-if="loadingShow" type="circular"></Loading>
    </transition>
    <player ref="player" class="playerOuter" v-if="visPlayer"></player>
  </div>
</template>
<script>
import loading from '@/components/loading.vue'
import player from './components/player'

export default {
    name: 'App',
    provide () {
        return {
            app: this
        }
    },
    data () {
        return {
            loadingShow: false,
            // visPlayer: false
        }
    },
    components: {
        'Loading': loading,
        player
    // 'loadingDot': loadingDot,
    },
    computed: {
      visPlayer() {
          return this.$store.state.playerStatus;
      },
      audioObj() {
          return this.$store.state.audioObj;
      }
    },
    mounted() {
      let lan = window.localStorage.getItem('lan')
      
      if (lan) {
        this.$store.commit('setLan', lan);
      } else {
        this.$store.commit('setLan', 1);
      }
    },
    methods: {
        showLoading () {
            this.loadingShow = true
        },
        hideLoading () {
            this.loadingShow = false
        },
        setSmall() {
          this.$refs.player.setSmall()
        }
    }
}

</script>
<style lang="scss">
#app{
  width: 100%;
  min-height: 100vh;
  // background: url('../static/img/bg.png');
  background-size: 100% auto;
  background-repeat: repeat-y;
  overflow: hidden;
}
/* 自定义颜色 */
#nprogress .bar {
  background-color: #AD2229 !important;
}

.demo-enter-active,
.demo-leave-active {
  transition: 0.3s ease-out;
}

.demo-enter {
  opacity: 0;
}

.demo-leave-to {
  opacity: 0;
}
.playerOuter{
  position: fixed;
  right: 0;
  top: 602px;
  z-index: 200;
}

</style>



// WEBPACK FOOTER //
// src/App.vue